import React from 'react';
import { Link } from 'react-router-dom';
import { getRelatedProducts } from '../../data/productsData';
import './RelatedProducts.css';

const RelatedProducts = ({ currentSlug }) => {
  const relatedList = getRelatedProducts(currentSlug);

  if (!relatedList || relatedList.length === 0) {
    return null;
  }

  return (

    <section className="related-products-section">
      <div className="related-products-container">
        
        {/* Section Main Title */}
        <h2 className="related-products-title">Explore Related Machines</h2>

        {/* 2x2 Dark Cards Grid */}
        <div className="related-products-grid">
          {relatedList.map((item) => (
            <Link 
              to={`/product/${item.slug}`} 
              className="related-product-card" 
              key={item.id}
              onClick={() => window.scrollTo(0, 0)}
            >
              {/* Card Left Image */}
              <div className="related-card-img-wrapper">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="related-card-img" 
                />
              </div>

              {/* Card Right Text Content & Action Badge */}
              <div className="related-card-content">
                <div className="related-card-text-block">
                  <h3 className="related-card-item-title">{item.title}</h3>
                  <p className="related-card-item-desc">{item.description}</p>
                </div>

                <div className="related-card-action-badge">
                  <svg 
                    width="18" 
                    height="18" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default RelatedProducts;
